import { DynamicContentListData } from '../../model.ts';
import { getKeys } from '../../../../../../_helpers/keyboard.ts';
import { sendDataLinkEvent } from '../../../../../../components/blackrock/advisor-center/_helpers/dataLinkEventHelper.ts';

export type CallToActionProps = {
	data: DynamicContentListData;
	onClick?: () => void;
	isVisible?: boolean;
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const CallToAction: React.FC<CallToActionProps> = ({
	data,
	onClick,
	isVisible,
}) => {
	if (data.variant === 'insights') {
		const loadMoreLabel =
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			data.translationMap.loadMoreButton;
		const isButtonVisible = isVisible && loadMoreLabel;

		const onKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>) => {
			const keys = getKeys(event);

			if (keys.isEnter || keys.isSpace) {
				event.preventDefault();
				event.stopPropagation();
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				onClick();
			}
		};

		return (
			isButtonVisible && (
				<button
					className="blk-ac-primary-button default-icon"
					onClick={onClick}
					type="button"
					role="button"
					onKeyDown={onKeyDown}
				>
					{loadMoreLabel}
				</button>
			)
		);
	} else {
		const isButtonVisible =
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			isVisible && data?.callToAction.url && data?.callToAction.label;

		return (
			isButtonVisible && (
				<a
					data-final-url
					className="blk-ac-secondary-button default-icon cta"
					href={data?.callToAction?.url}
					target={data?.callToAction?.target}
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					// @ts-ignore
					onClick={() => sendDataLinkEvent(data?.callToAction?.dataLinkEvent)}
					aria-label={data?.callToAction?.ariaLabel}
					role="link"
				>
					{/* // eslint-disable-next-line @typescript-eslint/ban-ts-comment //
					@ts-ignore */}
					{data?.callToAction.label}
				</a>
			)
		);
	}
};

export default CallToAction;
